module.exports = __webpack_public_path__ + "static/team_stefanie.c7a6fc29.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/team_stefanie.png
// module id = 384
// module chunks = 35783957827783 114276838955818